import ApplicationSettings from './ApplicationSettings';

export default ApplicationSettings;
